import { useCallback, useEffect, useState } from "react";
import { AlarmClock, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { fmtDate } from "../lib/roles";
import { Empty, Field, Loading, PageHeader, Panel } from "../components/common";
import { Textarea } from "../components/ui/textarea";
import { Input } from "../components/ui/input";
import { Switch } from "../components/ui/switch";
import { Button } from "../components/ui/button";

export default function Postit() {
  const [list, setList] = useState(null);
  const [testo, setTesto] = useState("");
  const [alarm, setAlarm] = useState(false);
  const [giorno, setGiorno] = useState("");
  const [ora, setOra] = useState("");
  const load = useCallback(() => api("/postits").then((d) => setList(d.postits || [])).catch(() => setList([])), []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    if (!testo.trim()) return toast.error("Inserisci il testo del post-it");
    if (alarm && (!giorno || !ora)) return toast.error("Imposta giorno e ora della sveglia");
    const sveglia = alarm ? new Date(`${giorno}T${ora}:00`).toISOString() : "";
    try { await api("/postits", { method: "POST", body: { testo: testo.trim(), sveglia } }); toast.success("Post-it salvato"); setTesto(""); setAlarm(false); load(); } catch (e) { toast.error(e.message); }
  };
  const del = async (id) => {
    if (!window.confirm("Vuoi eliminare questo post-it?")) return;
    try { await api(`/postits/${id}`, { method: "DELETE" }); load(); } catch { toast.error("Errore eliminazione"); }
  };

  return (
    <div>
      <PageHeader subtitle="Appunti e promemoria" title="I miei Post-it" />
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-8">
        <Panel className="space-y-4 h-fit">
          <h2 className="font-display font-bold text-[var(--navy)]">Nuovo post-it</h2>
          <Textarea rows={4} value={testo} onChange={(e) => setTesto(e.target.value)} placeholder="Scrivi il tuo appunto..." data-testid="postit-text-input" />
          <div className="flex items-center justify-between"><span className="text-sm">Imposta una sveglia (promemoria)</span><Switch checked={alarm} onCheckedChange={setAlarm} data-testid="postit-alarm-switch" /></div>
          {alarm && <div className="grid grid-cols-2 gap-3"><Field label="Giorno"><Input type="date" value={giorno} onChange={(e) => setGiorno(e.target.value)} data-testid="postit-day-input" /></Field><Field label="Ora"><Input type="time" value={ora} onChange={(e) => setOra(e.target.value)} data-testid="postit-time-input" /></Field></div>}
          <Button onClick={save} className="rounded-full bg-[var(--teal)] w-full" data-testid="postit-save-button">Salva</Button>
        </Panel>
        {!list ? <Loading /> : list.length === 0 ? <Empty title="Nessun post-it" text="Aggiungi un appunto o un promemoria." /> : (
          <div className="grid sm:grid-cols-2 gap-4 items-start stagger" data-testid="postit-list">{list.map((p, i) => (
            <div key={p.id} className="rounded-2xl p-5 bg-[#FEF3A8] shadow-sm relative" style={{ transform: `rotate(${i % 2 ? 1 : -1}deg)` }} data-testid={`postit-${p.id}`}>
              <p className="whitespace-pre-wrap text-[#3b3415] pr-6">{p.testo}</p>
              {p.sveglia && <p className="text-xs mt-3 text-[#7a6a1f] flex items-center gap-1"><AlarmClock className="w-3 h-3" />{p.notified ? "Notificato · " : "Sveglia · "}{fmtDate(p.sveglia, true)}</p>}
              <button onClick={() => del(p.id)} className="absolute top-3 right-3 text-[#7a6a1f] hover:text-[var(--red)]" data-testid={`postit-delete-${p.id}`}><Trash2 className="w-4 h-4" /></button>
            </div>))}
          </div>)}
      </div>
    </div>
  );
}
